/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { InteractiveComponents } from '../../../core/enums';
import { Log } from '../../../core/logging';
import type { TGetState } from '../../../core/tivo/tivo-redux-wrapper';
import { setActiveInteractiveComponent } from '../../interactivelayer/interactiveLayer.reducers';
import {
    biaxialWidgetUpdateHorizontalPositionAction,
    biaxialWidgetUpdateVerticalPositionAction,
} from '../biaxialwidget.actions';
import { biaxialWidgetUpdateCaretVisible } from '../biaxialwidget.reducers';

const TAG = 'biaxialWidgetNavigation';

export const onKeyDownBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { verticalItems, verticalPosition } = getState().biaxialWidget;
    if (!verticalItems.length) return;

    if (verticalPosition < verticalItems.length - 1) {
        dispatch(biaxialWidgetUpdateVerticalPositionAction(verticalPosition + 1));
    }
    Log.i(
        TAG,
        'onKeyDownBiaxialWidget action dispatched, verticalPosition: ',
        verticalPosition + 1,
    );
};

export const onKeyLeftBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { horizontalItem, horizontalPosition } = getState().biaxialWidget;
    if (!horizontalItem.listItems.length) return;

    const newPosition =
        horizontalPosition > 0 ? horizontalPosition - 1 : horizontalItem.listItems.length - 1;
    dispatch(biaxialWidgetUpdateHorizontalPositionAction(newPosition));

    Log.i(TAG, 'onKeyLeftBiaxialWidget action dispatched, horizontalPosition: ', newPosition);
};

export const onKeyRightBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { horizontalItem, horizontalPosition } = getState().biaxialWidget;
    if (!horizontalItem.listItems.length) return;

    const newPosition =
        horizontalPosition < horizontalItem.listItems.length - 1 ? horizontalPosition + 1 : 0;
    dispatch(biaxialWidgetUpdateHorizontalPositionAction(newPosition));

    Log.i(TAG, 'onKeyRightBiaxialWidget action dispatched, horizontalPosition: ', newPosition);
};

export const onKeyUpBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { verticalItems, verticalPosition } = getState().biaxialWidget;
    if (!verticalItems.length) return;

    if (verticalPosition > 0) {
        dispatch(biaxialWidgetUpdateVerticalPositionAction(verticalPosition - 1));
    }
    Log.i(TAG, 'onKeyUpBiaxialWidget action dispatched, verticalPosition: ', verticalPosition - 1);
};

export const onMouseOutBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { inputFactory } = getState();
    const { value } = inputFactory;
    if (
        value === InteractiveComponents.NORTH ||
        value === InteractiveComponents.SOUTH ||
        value === InteractiveComponents.EAST ||
        value === InteractiveComponents.WEST
    ) {
        dispatch(biaxialWidgetUpdateCaretVisible(false));
    }
};

export const onMouseOverBiaxialWidget = () => (dispatch: Function, getState: TGetState) => {
    const { value } = getState().inputFactory;
    if (value === InteractiveComponents.NORTH) {
        dispatch(setActiveInteractiveComponent(value));
        dispatch(biaxialWidgetUpdateCaretVisible(true));
    } else if (value === InteractiveComponents.SOUTH) {
        dispatch(setActiveInteractiveComponent(value));
        dispatch(biaxialWidgetUpdateCaretVisible(true));
    } else if (value === InteractiveComponents.EAST) {
        dispatch(setActiveInteractiveComponent(InteractiveComponents.EAST));
        dispatch(biaxialWidgetUpdateCaretVisible(true));
    } else if (value === InteractiveComponents.WEST) {
        dispatch(setActiveInteractiveComponent(InteractiveComponents.WEST));
        dispatch(biaxialWidgetUpdateCaretVisible(true));
    }
};
